module.exports = __webpack_public_path__ + "img/magnifier.7c8cfc59.png";